{
    "name": "@delab/ix.lab-frontend",
    "version": "2.0.5",
    "description": "ix-lab: Portal für niederschwellige Einsender - Frontend",
    "private": true,
    "scripts": {
        "ng": "ng",
        "start:dev": "ng serve",
        "watch:dev": "ng build --watch --configuration development",
        "build:dev": "ng build --configuration development",
        "build:prod-devmode": "ng build --configuration production-devmode",
        "analyze-bundle": "ng build --stats-json && webpack-bundle-analyzer ../dist/client/stats.json",
        "reinstall:components": "rm -f package-lock.json && rm -rf node_modules/@delab/ngx-ixconnect-components && npm install",
        "build": "ng build",
        "test": "ng test"
    },
    "dependencies": {
        "@angular/animations": "~21.2.22",
        "@angular/cdk": "~21.2.14",
        "@angular/common": "~21.2.22",
        "@angular/compiler": "~21.2.22",
        "@angular/core": "~21.2.22",
        "@angular/forms": "~21.2.22",
        "@angular/material": "~21.2.14",
        "@angular/platform-browser": "~21.2.22",
        "@angular/platform-browser-dynamic": "~21.2.22",
        "@angular/router": "~21.2.22",
        "@delab/ngx-gen-ts-ixserv": "12.0.4",
        "@delab/ngx-ixconnect-components": "12.0.6",
        "@material-design-icons/font": "^0.14.15",
        "class-transformer": "0.5.1",
        "class-validator": "0.15.1",
        "material-symbols": "^0.47.1",
        "ngx-mat-timepicker": "21.0.1",
        "ngx-pipes": "3.2.2",
        "postcss": "^8.5.28",
        "rxjs": "7.8.2",
        "tslib": "2.8.1",
        "uuid": "^14.0.2",
        "zone.js": "~0.16.1"
    },
    "devDependencies": {
        "@angular/build": "~21.2.23",
        "@angular/cli": "^21.2.23",
        "@angular/compiler-cli": "~21.2.22",
        "@tailwindcss/container-queries": "^0.1.1",
        "@tailwindcss/forms": "^0.5.11",
        "@tailwindcss/postcss": "^4.3.3",
        "@types/jasmine": "~6.0.0",
        "@types/karma": "^6.3.9",
        "@types/node": "^24.13.3",
        "jasmine-core": "~7.0.2",
        "karma": "~6.4.4",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.1",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.3.0",
        "tailwindcss": "^4.2.4",
        "typescript": "~5.9.3",
        "webpack-bundle-analyzer": "^5.3.2"
    }
}
